<template>
  <div class="container button-group">
    <b-button type="submit" class="button-blue" @click="onClientClick">
      Já sou cliente
    </b-button>
    <a :href="solutionsLink" class="button-bp-solutions">
      Conheça as soluções <i>BP</i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BpButtonGroup',
  props: {
    onClientClick: {
      type: Function,
      required: true,
    },
    solutionsLink: {
      type: String,
      default: 'https://www.bpseguradora.com.br/',
    },
  },
};
</script>

<style scoped>
.button-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 3.5rem;
}

.button-blue {
  font-family: 'montserratbold', sans-serif;
  background-color: #2b50bb;
  color: #ffffff;
  border-radius: 8px !important;
  padding: 10px 0px;
  font-size: 1rem;
  width: 100%;
  text-transform: none;
}

.button-bp-solutions {
  font-family: 'montserratbold', sans-serif;
  background-color: transparent;
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 0px;
  font-size: 1rem;
  width: 100%;
  text-transform: none;
  border: 2px solid #2b50bb;
  text-decoration: none;
}
</style>
